import { CardPaymentModule } from '@/components/modules/SinglePayment/CardPayment/CardPayment';
import { DYNAMIC_PAGE_PATHS } from '@/components/views/DynamicPageView/config/shared/pathRoutes';
import { WIDGETS } from '@/components/views/DynamicPageView/config/shared/widgets';
import { ALL_CORE_APP_ROLES, ALL_CORE_APP_USER_TYPES } from '@/config/config';
import { ApplicationType, PageScheme } from '@/config/types';

export const PAGE_CARD_PAYMENT: PageScheme = {
  path: DYNAMIC_PAGE_PATHS.CARD_PAYMENT,
  showIfAllowedProduct: ApplicationType.CARD_PAYMENT,
  schemesByRoles: [
    {
      roles: [...ALL_CORE_APP_ROLES],
      titleTextId: 'CARD_PAYMENT_DETAIL',
      widgets: [
        {
          id: WIDGETS.CHECKOUT_SESSION_PAGE_TITLE,
          roles: [...ALL_CORE_APP_ROLES],
          props: {},
          notShownInRightMenu: true,
        },
      ],
    },
  ],
  sections: [
    {
      textId: 'SUMMARY',
      module: (
        <CardPaymentModule
          permissions={{
            view: ALL_CORE_APP_USER_TYPES,
          }}
        />
      ),
    },
  ],
};
